<template>
    <div />
</template>

<script lang="ts">
import { AuthGetters } from "@/store/modules/auth";
import { RESOURCE_MANAGER_STATUS } from "@/utils/CreativeIntelligenceApi";

export default {
    name: "CampaignDataProvider",

    props: {
        options: {
            type: Object
        },

        refreshCounter: {
            type: Number,
            default: 0
        },

        requestOptions: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    emits: ["data", "error", "loading"],

    data() {
        return {
            isLoading: false,
            fetchCount: 0
        };
    },
    computed: {
        apiInfo() {
            return this.$store.getters[AuthGetters.contentGenerationApiInfo];
        },

        userId() {
            return this.$store.state.auth.me?.reference;
        },

        requestBody() {
            return this.options;
        },

        requestEndpoint() {
            return `${this.apiInfo.url}/v1/resource/okta/request/${this.userId}`;
        },

        mergedRequestOptions() {
            return {
                mode: "cors",
                cache: "no-cache",
                headers: {
                    "Content-Type": "application/json"
                },
                credentials: "same-origin",
                referrerPolicy: "no-referrer",
                method: "POST",
                body: JSON.stringify(this.requestBody),
                redirect: "follow",
                ...this.requestOptions
            };
        }
    },

    watch: {
        options: {
            immediate: true,
            deep: true,
            handler() {
                this.fetch();
            }
        },

        refreshCounter() {
            this.fetch();
        }
    },

    methods: {
        async fetch() {
            this.fetchCount += 1;

            try {
                this.isLoading = true;
                this.$emit("loading", this.isLoading);

                const response = await fetch(this.requestEndpoint, {
                    ...this.mergedRequestOptions,
                    headers: {
                        ...this.mergedRequestOptions.headers,
                        Authorization: await this.$auth.getIdToken()
                    }
                });

                if (!response.ok) {
                    this.$emit("error", { response });
                } else {
                    const responseJson = await response.json();

                    if (responseJson.data?.status === RESOURCE_MANAGER_STATUS.IN_PROGRESS) {
                        setTimeout(this.fetch, 2500);

                        return;
                    }

                    if (responseJson.data?.status === RESOURCE_MANAGER_STATUS.FAILED) {
                        try {
                            this.$emit("error", { message: JSON.parse(responseJson.data.output.fail) });
                        } catch {
                            this.$emit("error", { message: responseJson.data.output.fail });
                        }

                        return;
                    }

                    this.$emit("data", { ...responseJson.data, searchOptions: this.options });
                }

                this.isLoading = false;
                this.$emit("loading", this.isLoading);
            } catch (e) {
                this.$emit("error", e);
                this.isLoading = false;
                this.$emit("loading", this.isLoading);
                throw e;
            }
        }
    }
};
</script>
